import { createSelector } from '@ngrx/store';
import { AppStateInterface } from '../types';

export const activeLanguage = (state: AppStateInterface) =>
  state.activeLanguage;

export const selectActiveLanguage = createSelector(
  activeLanguage,
  (state) => state.activeLanguage,
);
